import _ from 'lodash';

function Vehicle(data) {
    if (data) {
        _.extend(this, data);
    }
}

Vehicle.prototype.getDisplayName = function (defaultName, TranslateService) {
    let name = this.make || '';
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }
    if (this.year) {
        if (name) {
            name += ' ';
        }
        name += this.year;
    }
    if (!name) {
        name = defaultName || TranslateService.instant('fnol.common.model.Unnamed');
    }
    return name;
};

export default Vehicle;
